export enum PLOT_STATUSES {
  PREPARING = 'preparing',
  DRAFT = 'draft',
  PENDING = 'pending',
  RUNNING = 'running',
  COMPLETE = 'complete',
  FINALIZING = 'finalizing',
  ERRORED = 'errored',
}

export default PLOT_STATUSES;

